module.exports = __webpack_public_path__ + "static/scale-model-of-robin-williams'-star-in-glendale-california-2eaf9d4b20fcf975e17462870ca8bd74.png";